import { render, staticRenderFns } from "./BaseEventManager.vue?vue&type=template&id=1555d458"
import script from "./BaseEventManager.vue?vue&type=script&lang=js"
export * from "./BaseEventManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports